import { Modal, ModalProps } from 'antd'
import { SignTitle } from '../sign-title'
import { IconFont } from '@/components'
import styled from 'styled-components'
import { t } from '@/i18n'
interface DeleteModalProps extends ModalProps {
  text?: string | any
  loading?: boolean
}
export const DeleteModal = (props: DeleteModalProps) => {
  const { text, loading, ...other } = props
  return (
    <ModalItem
      loading={loading}
      centered
      title={<SignTitle show>{t('提示')}</SignTitle>}
      {...other}
    >
      <Icon type={'icon-tixingshixin'} />
      {text || t('此操作将永久删除，是否继续？')}
    </ModalItem>
  )
}

const Icon = styled(IconFont)`
  color: #faad14;
  font-size: 18px;
  margin-right: 12px;
  transform: translateY(2px);
`

const ModalItem = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
    position: relative;

    .ant-modal-close {
      width: 36px;
      height: 36px;
      background: #d8d6f4;
      box-shadow: -1px 4px 10px 0px #c7c7c7;
      border-radius: 6px;
      border: none;
      color: #4238c9;
      font-size: 16px;
      font-weight: 500;
      position: absolute;
      right: -8px;
      top: -8px;
      transition: transform 0.3s ease;

      &:hover {
        transform: translate(-18px, 18px);
        box-shadow: 0 0 0 0;
      }

      .ant-modal-close-x {
        width: 100%;
        height: 100%;
        line-height: 36px;
        text-align: center;
      }
    }

    .ant-modal-header {
      height: 56px;
      background: #f2f0ff;
      border-bottom: none;
      margin: 0;
    }
  }
`
